import { render, staticRenderFns } from "./OrderItemsBreakdownTable.vue?vue&type=template&id=1a4d2e5e&scoped=true&"
import script from "./OrderItemsBreakdownTable.vue?vue&type=script&lang=js&"
export * from "./OrderItemsBreakdownTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemsBreakdownTable.vue?vue&type=style&index=0&id=1a4d2e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4d2e5e",
  null
  
)

export default component.exports